import { Component, OnInit } from '@angular/core';
import { NewsService } from 'src/app/shared/services/news.service';
import * as moment from 'moment'

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {

  newsList: any = "";
  last_newsletter_id: any = 0;
  request: any = {
    pagesize: 6,
    page: 1
  };
  newsList_last_page: boolean;

  constructor(
  private newsService: NewsService) {
    this.loadNews();
   }

  ngOnInit(): void {
  	// this.newsService.getNews().then((data) => {
	  //     this.newsList = data;
	  //     console.log(this.newsList);
	  //   });
      
  }
  getMoreNews() {
    this.request.newsletter_id = this.last_newsletter_id;
    this.loadNews(true);
    
  }
  loadNews(concat:boolean = false){
    let request = Object.assign({}, this.request)
  this.newsService.getNews(request).then((data : any) => { 
   if(data.data.length > 0)
   {
     this.last_newsletter_id = data.data[5].newsletter_id;
     if (concat) {
      this.newsList = this.newsList.concat(data.data);
      //console.log(this.newsList);
      //this.shareNews();
    } else {
      this.newsList = data.data;
      //console.log(this.newsList);
      //this.shareNews();
    }   
   }
   else{
    this.newsList_last_page = true;
    //console.log("hello");
    
   }
});
}

}
